import React from 'react';
import PropTypes from 'prop-types';
import CompanySettingView from '../company-settings-form-view';
import { CompanySettingsForm } from '../company-settings-form';

export const CompanySettingsContent = ({
	isCompanySettingInfoLoading,
	formValues,
	companySettingInfo,
	isEditing,
	change,
	stages,
	documentTypes,
	isStagesLoading,
	isDocumentsTypesLoading,
}) => {
	if (isEditing) {
		return (
			<CompanySettingsForm
				formValues={formValues}
				change={change}
				companySettingInfo={companySettingInfo}
				stages={stages}
				documentTypes={documentTypes}
				isDocumentsTypesLoading={isDocumentsTypesLoading}
				isStagesLoading={isStagesLoading}
			/>
		);
	}

	return (
		<CompanySettingView
			companySettingInfo={companySettingInfo}
			isCompanySettingInfoLoading={isCompanySettingInfoLoading}
			formValues={formValues}
		/>
	);
};

CompanySettingsContent.propTypes = {
	companySettingInfo: PropTypes.object,
	isCompanySettingInfoLoading: PropTypes.bool.isRequired,
	isEditing: PropTypes.bool.isRequired,
	formValues: PropTypes.object,
	change: PropTypes.func.isRequired,
	initialValues: PropTypes.array,
	stages: PropTypes.array,
	documentTypes: PropTypes.array,
	isDocumentsTypesLoading: PropTypes.bool.isRequired,
	isStagesLoading: PropTypes.bool.isRequired,
};
